import { memo } from 'react';
import { CheckBoxGroup, ColorType, GroupDirection, LabelType } from '..';
import { CheckBoxData } from './types/CheckBox-Column.interface';

interface RadioGroupProps {
  direction?: GroupDirection;
  defaultItems: CheckBoxData[];
  onChange: Function;
  translationOn?: boolean;
  itemHeight?: string;
  selectedLabelColor?: string;
  padding?: string;
  labelType?: LabelType;
  secondaryLabelType?: LabelType;
  secondaryLabelColor?: ColorType;
  itemWidth?: string;
  dataTestId?: string;
}

const RadioGroup = ({
  direction = GroupDirection.Horizontal,
  defaultItems,
  onChange,
  selectedLabelColor,
  translationOn = false,
  itemHeight = '40px',
  itemWidth,
  labelType = LabelType.BODY3,
  secondaryLabelType = LabelType.BODY3,
  secondaryLabelColor = ColorType.BLACK,
  padding,
  dataTestId = '',
}: RadioGroupProps) => (
  <CheckBoxGroup
    defaultItems={defaultItems}
    direction={direction}
    singleSelection
    onChange={onChange}
    translationOn={translationOn}
    itemHeight={itemHeight}
    selectedLabelColor={selectedLabelColor}
    padding={padding}
    labelType={labelType}
    secondaryLabelType={secondaryLabelType}
    secondaryLabelColor={secondaryLabelColor}
    itemWidth={itemWidth}
    dataTestId={dataTestId}
  />
);

export default memo<RadioGroupProps>(RadioGroup);
